import { render, staticRenderFns } from "./Rank.vue?vue&type=template&id=4be62d2a&scoped=true"
import script from "./Rank.vue?vue&type=script&lang=js"
export * from "./Rank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be62d2a",
  null
  
)

export default component.exports